export default __webpack_public_path__ + "static/media/clickhouselogo.61d3a2ea.png";